import styled from "styled-components";
import { CharacterFile } from "common/character/dto/CharacterFile";
import { useEffect, useMemo, useState } from "react";
import { imageTitleGet, characterImageSrc } from "./CharacterImage.logic";

type CharacterImageProps = {
  characterFile: CharacterFile;
  small?: boolean;
};

const CharacterImage = ({ characterFile, small }: CharacterImageProps) => {
  const [imageSrc, setImageSrc] = useState<any>(null);
  const maxHeight = useMemo(() => {
    let mH = "200px";
    if (small) {
      mH = "30px";
    }
    return mH;
  }, []);
  useEffect(() => {
    const imagePath: string = characterFile.small?.path ?? characterFile.path;
    characterImageSrc(imagePath).then((imSrc) => {
      setImageSrc(imSrc);
    });
  }, []);

  const title: string = imageTitleGet(characterFile);

  return (
    <div>
      {imageSrc && <Img maxHeight={maxHeight} src={imageSrc} title={title} />}
    </div>
  );
};

const Img = styled.img<{ maxHeight?: string }>`
  margin-top: 0.5rem;
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : "200px")};
`;

export default CharacterImage;
